export default __webpack_public_path__ + "static/cruiselines-vv-ship-2-23ebc284281cf9f937730ca84c8ab1da.jpg";